import React from 'react'
import styled from 'styled-components'

const Changes = styled.div`
  color: ${({ theme }) => theme.palette.success[0]};
`

const New = styled.div`
  color:  ${({ theme }) => theme.palette.danger[0]};
  &:before {
    content: "\u2605 NEW!"
  }
`

function calculateUpdates({ differences: { meta = {} } = {} }) {
  const { additions = 0, differences = 0 } = meta
  return additions + differences
}

const TypeOfChange = ({ stagedScholarship }) => {
  const calculated = calculateUpdates(stagedScholarship)
  return stagedScholarship.differences ?
    <Changes className="p-1">
      <div className="font-weight-bold">UPDATE</div>
      {calculated} {calculated > 1 ? 'Changes' : 'Change'}
    </Changes>
    : <New />
}

export default TypeOfChange
